import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { incomeSummaryService, IIncomeSummarySearchFields, IIncomeSummaryDetail, IIncomeEnum, ISummaryDetail } from "./incomeSummaryService";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";


export const useIncomeSummaryModel = createModel(function () {
    const { shopAndOrg: { shopId },setLoadingInfo } = useGlobalModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IIncomeSummarySearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IIncomeSummaryDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const updateSearchParam = (updateParam: IIncomeSummarySearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    // tabs页签切换
    const [tabsType, setTabsType] = useState<IIncomeEnum>(IIncomeEnum.INCOMEDETAILS)
    // 收入汇总
    const [summaryDataSource, setSummaryDataSource] = useState<ISummaryDetail[]>([]);
    //全年成本
    const [costDataSource, setCostDataSource] = useState<ISummaryDetail[]>([]);
    //收入明细
    const [incomeDetailsDataSource, setincomeDetailsDataSource] = useState<ISummaryDetail[]>([]);

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IIncomeSummarySearchFields = searchParam) => {
        let { retData } = await incomeSummaryService.page(shopId);
        let newRecords = retData.map(item => ({
            ...item,
            id: item.day
        })).sort((a, b) => a.day - b.day)
        setDataSource(newRecords);
    }
    //加载收入汇总
    const summaryLoadData = async () => {
        let { retData } = await incomeSummaryService.summary(shopId);
        let newRecords = retData.map(item => ({
            ...item,
            id: item.day
        })).sort((a, b) => a.day - b.day)
        setSummaryDataSource(newRecords);
    }
    //加载收入明细
    const incomeDetailLoadData = async (page: ISearchPage = initPgCfg, searchValue: IIncomeSummarySearchFields = searchParam) => {
        let searchParams = {
            ...searchValue,
            shopId,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await incomeSummaryService.income(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setincomeDetailsDataSource(records);

    }
    const onExport = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })

        const searchParams = {
            pageSize: -1,
            pageNum: 1,
            ...searchParam,
            shopId,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await incomeSummaryService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch  {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        initPgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        tabsType, setTabsType,
        summaryDataSource, setSummaryDataSource,
        costDataSource, setCostDataSource,
        incomeDetailsDataSource, setincomeDetailsDataSource,
        summaryLoadData,
        incomeDetailLoadData,
        onExport
    }
});


